export const markdownUnwrapper = (data, language) =>
  data.allMarkdownRemark.edges.map((edge) => unwrapNode(edge.node, language));

export const unwrapNode = (node, language) => ({
  ...node.frontmatter.de,
  ...node.frontmatter[language],
});
